import styled from "styled-components";
import topBtn from "resources/topButton.png";
import icnChiness from "resources/iconsChiness.png";
import icnPPT from "resources/icnPPT.png";

export const Container = styled.div`
  width: 1340px;
  margin: 0 auto;
`;

export const FontNameContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
export const FontName = styled.p`
  display: inline-block;
  font-size: 78px;
  color: #000000;
  margin-top: 84px;
  padding: 5px 30px;
  font-family: ${(props) =>
    props.brush ? "var(--hyGothic)" : props.webFontName};
  border-right: 7px solid #d9d9d9;
  border-left: 7px solid #d9d9d9;
  @media print {
    margin-top: 0;
  }
`;

export const Concept = styled.div`
  display: flex;
  width: 600px;
  font-size: 16px;
  padding-top: 50px;
  font-family: var(--hyGothic);
  line-height: 1.8;
`;

export const FontInfoContainer = styled.div`
  display: flex;
  width: 1340px;

  flex-direction: column;
  align-content: center;
  align-items: center;
`;

export const IconChiness = styled.img.attrs({
  src: icnChiness,
})`
  display: inline;
  width: 21px;
  height: 19px;
  vertical-align: middle;
`;

export const InputConatiner = styled.div`
  margin-top: 85px;
  height: 50px;
  width: 900px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #bcbbbb;
`;

export const FontInput = styled.input`
  width: 100%;
  height: 49px;
  text-align: left;
  font-family: 'hy1148100115';
  font-size: 18px;
  border: none;
  padding: 0;
  &::placeholder {
    color: #9f9f9f;
    text-align: center;
  }
  &:focus {
    outline: none;
  }
`;

export const RangeBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const MinFontSize = styled.span`
  font-size: 18px;
  color: #575859;
`;

export const MaxFontSize = styled.span`
  font-size: 28px;
  color: #575859;
`;

export const FontSizeValue = styled.p`
  color: #696969;
  text-size: 13px;
  position: absolute;
  top: -15px;
`;

export const FontSize = styled.input`
  -webkit-appearance: none;
  margin: 0 10px;
  width: 155px;
  backgrond: transparent;
  height: 7px;
  background-color: #b1b1b1;
  border-radius: 4px;
  &:focus {
    outline: none;
  }
  &::-webkit-slider-thumb {
    appearance: none;
    background: #2ec0a9;
    cursor: pointer;
    height: 26px;
    width: 26px;
    border-radius: 13px;
  }
  &::-moz-range-thumb {
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #2ec0a9;
    cursor: pointer;
  }
  &::-ms-thumb {
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #2ec0a9;
    cursor: pointer;
  }
`;

export const FontView = styled.div`
  width: 900px;
  margin: 50px 0;
  display: inline-block;
`;

export const FontPreviewName = styled.p`
  margin-top: 20px;
  margin-bottom: 13px;
  font-size: 14px;
  font-family: var(--hyGothic);
  color: 9b9b9b;
  position: relative;
  left: 12px;
`;

export const FontPreview = styled.input`
  width: 1340px;
  border: none;
  padding-top: 0px;
  font-family: ${(props) => props.webfontname};
  background-color: white;
  margin-bottom: 30px;
`;

export const BrushPreview = styled.p`
    width:1340px;
    margin-top:50px;
    height=auto;
    font-size:17px;
    font-family:${(props) => props.webfontname};
    &>span{
        display:block;
        margin-bottom:15px;
    }
`;

export const StoryView = styled.div`
  width: 900px;
  height: auto;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
`;

export const StoryMainImage = styled.div`
  background-image: url(${(props) => props.url});
  width: 100%;
  margin-top: 20px;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const MoreStoryImage = styled.ul`
  width: 900px;

  transition: 1s max-height;
  /* overflow: hidden; */
`;

export const StoryImageItem = styled.li`
  height: auto;
  display: flex;
  justify-content: center;
`;

export const StoryShowMore = styled.img.attrs((props) => ({ src: props.img }))`
  display: inline;
  width: 50px;
  height: 50px;
  margin-top: 30px;
  &:hover {
    cursor: pointer;
  }
`;

export const FontDetaiSubTitle = styled.p`
  font-size: 48px;
  font-family: HYgothicL;
  color: #000000;
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 30px;
`;

export const FontStorySubTitle = styled.p`
  font-size: 34px;
  font-family: hy1148100384;
  color: #000000;
  display: flex;
  justify-content: center;
`;
export const FontStroyInnerTitle = styled.p`
  font-family: hy1148100384;
  font-size: 34px;
  color: #000000;
  display: flex;
  justify-content: center;
  margin: 10px 0;
`;

export const FontInfoTabList = styled.ul`
  margin-top: 20px;
  font-size: 20px;
  font-family: hy1148100116;
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.align};
  margin-right: 120px;
`;

export const FontInfoTab = styled.li`
  font-size: 18px;
  font-family: hy1148100116;
  margin-left: 20px;
  font-weight: 500;
  cursor: pointer;
  color: ${(props) => (props.selected ? "#2ec0a9" : "#000000")};
`;
export const ButtonBox = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin: 100px auto;
`;

export const BottomButton = styled.button`
  width: 200px;
  height: 36px;
  font-family: hy1148100115;
  border: none;
  color: #7e7e7e;
  background-color: white;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: 0;
  border-radius: 3px;
  margin-right: 10px;
  &:hover {
    color: #4b4b4b;
  }
  z-index: 99;
`;
export const TopButton = styled.div`
  width: 39px;
  height: 37px;
  background-image: url(${topBtn});
  cursor: pointer;
  position: fixed;
  bottom: 120px;
  right: 130px;
  z-index: 99;
`;

export const PPTButton = styled.div`
  width: 136px;
  height: 90px;
  background-image: url(${icnPPT});
  background-repeat: no-repeat;
  cursor: pointer;
  position: fixed;
  bottom: 187px;
  right: 87px;
  z-index: 99;
`;

export const RemoveButton = styled.button`
  background-color: white;
  font-size: 13px;
  font-family: hy1148100115;
  border: none;
  cursor: pointer;
  outline: 0;
`;

export const FontContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 335px);
  grid-gap: 10px;
  @media print {
    grid-template-columns: repeat(4, 167px);
  }
  // @media only screen and (max-width: 1340px) {
  //     grid-template-columns: repeat(3, 335px);
  // }
  // @media only screen and (max-width: 1020px) {
  //     grid-template-columns: repeat(2, 335px);
  // }
  // @media only screen and (max-width: 810px) {
  //     grid-template-columns: repeat(1, 335px);
  // }
`;
